import {ReactRouteObject} from "base/src/utils/routeUtil"

import { BaseRouter } from "base/src/infra/routes/baseRoutes"
import Auth from "../../views/auth/auth";
import Central from "../../views/central/central";
import Perfil from "../../views/authPerfil/authPerfil";
import ConfirmarSenha from "../../views/confirmarSenha/confirmarSenha";

export const AuthRouter: ReactRouteObject[] = [
  ...BaseRouter,
  {
    path: "/",
    element: <Auth />,
    ignoreAuth:true,
    ignoreHeader:true,
    ignoreSideBar:true
  },
  {
    path: "central",
    element: <Central />,
  },
  {
    path: "perfil",
    element: <Perfil />,
    isDev:true
  },
  {
    path: "confirmar-senha",
    element: <ConfirmarSenha />,
    ignoreAuth:true,
    ignoreHeader:true,
    ignoreSideBar:true
  }
];

